<template>
  <ResponsiveModal
    :variant="variant"
    :title="title"
    :description="description"
    :showFooter="false"
  >
    <slot />
    <template #content>
      <div v-if="!maxSmall" class="h-5" />
      <Priorities
        ref="priorityRef"
        :initialState="initialState"
        :as="DialogClose"
        class="grow p-4 md:py-6 md:px-6 bg-primary md:bg-secondary"
        @click="priorityRef?.submit()"
        @submit="$emit('update', $event)"
      />
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ref } from "vue";
import { DialogClose } from "@/SharedComponents/Dialog";
import { Priorities } from "@/SharedComponents/Modals/Content";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["update"]);

const priorityRef = ref(null);

defineProps({
  variant: { type: String, required: false },
  title: { type: String, required: true },
  description: { type: String, required: true },
  initialState: { type: String, required: true },
});
</script>
